/**
 * 产品注册表 —— GeeWen 家族的产品清单
 *
 * ⚠️ 这是「有哪些产品」的唯一事实来源:
 *   - 首页产品卡 (GeewenPage) 按它渲染
 *   - 产品详情页 (GeewenProductPage) 按它找产品
 *   - 将来加第 3、第 4 个产品 ⇒ 这里加一条 + locale 里加一段文案就完事
 *
 * 文案一律走 locale (key = products.<slug>.*), 这里只放「结构性」的东西:
 *   slug (URL 段) / icon (FA) / accent (配色主题)
 */

/**
 * @typedef {object} GeeWenProduct
 * @property {string} slug    URL 段, 同时是 locale 里的 key
 * @property {string} icon    Font Awesome 类名
 * @property {string} accent  配色主题: scheduler (蓝) / dressup (绿)
 */

/** @type {GeeWenProduct[]} */
export const PRODUCTS = [{
  slug: 'scheduler',
  icon: 'fas fa-calendar-check',
  accent: 'scheduler'
}, {
  slug: 'dress-up',
  icon: 'fas fa-shirt',
  accent: 'dressup'
}];

/**
 * 按 slug 找产品; 找不到返回 null (详情页据此渲染「没找到」)。
 *
 * @param {string} slug
 * @returns {GeeWenProduct|null}
 */
export function findProduct(slug) {
  if (!slug) return null;
  return PRODUCTS.find(product => product.slug === slug) || null;
}

/**
 * 产品详情页 URL。
 *
 * @param {string} slug
 * @returns {string}
 */
export function productUrl(slug) {
  return '/geewen/' + slug;
}